export default "__VITE_ASSET__BWhjoakq__"